import { CheckoutCompletedItem, CheckoutResponse } from '@checkout/util-models';
import {
  CustomerDetails,
  CustomerMarketingPreferenceDetails,
  DocumentSendMethod,
} from '@domgen/dgx-fe-common';
import { createReducer, on } from '@ngrx/store';
import * as CheckoutActions from './checkout.actions';

export const CHECKOUT_FEATURE_KEY = 'checkout';

export interface CheckoutState {
  completedItems: CheckoutCompletedItem[];
  customerDetails?: CustomerDetails;
  purchasing: boolean;
}

const initialState: CheckoutState = {
  completedItems: [],
  customerDetails: undefined,
  purchasing: false,
};

export interface CheckoutPartialState {
  readonly [CHECKOUT_FEATURE_KEY]: CheckoutState;
}

export const checkoutReducer = createReducer(
  initialState,
  on(
    CheckoutActions.init,
    (state: CheckoutState): CheckoutState => ({
      ...state,
      purchasing: false,
    })
  ),
  on(
    CheckoutActions.upsertCustomerDetails,
    (
      state: CheckoutState,
      action: { customerDetails: CustomerDetails }
    ): CheckoutState => ({
      ...state,
      customerDetails: action.customerDetails,
    })
  ),
  on(
    CheckoutActions.upsertCustomerMarketingPreferenceDetails,
    (
      state: CheckoutState,
      action: { marketingPreferences: CustomerMarketingPreferenceDetails }
    ): CheckoutState => ({
      ...state,
      customerDetails: {
        ...state.customerDetails,
        marketingPreferences: action.marketingPreferences,
      } as CustomerDetails,
    })
  ),
  on(
    CheckoutActions.updateDocumentSendMethod,
    (
      state: CheckoutState,
      action: { documentSendMethod: DocumentSendMethod }
    ): CheckoutState => {
      if (!state.customerDetails) {
        return state;
      }

      return {
        ...state,
        customerDetails: {
          ...state.customerDetails,
          sendMethod: action.documentSendMethod,
        },
      };
    }
  ),
  on(
    CheckoutActions.checkout,
    (state: CheckoutState): CheckoutState => ({
      ...state,
      purchasing: true,
      completedItems: [],
    })
  ),
  on(
    CheckoutActions.checkoutSuccess,
    (
      state: CheckoutState,
      action: { checkoutResponse: CheckoutResponse }
    ): CheckoutState => ({
      ...state,
      completedItems: action.checkoutResponse.completedItems,
      purchasing: false,
    })
  ),
  on(
    CheckoutActions.checkoutFailure,
    (state: CheckoutState): CheckoutState => ({
      ...state,
      purchasing: false,
    })
  ),
  on(
    CheckoutActions.removeCompletedItems,
    (state: CheckoutState): CheckoutState => ({
      ...state,
      completedItems: [],
    })
  ),
  on(
    CheckoutActions.resetMarketingPreferences,
    (state: CheckoutState): CheckoutState => {
      if (!state.customerDetails) {
        return state;
      }

      return {
        ...state,
        customerDetails: {
          ...state.customerDetails,
          marketingPreferences: {
            email: false,
            post: true,
            telephone: false,
          },
          groupMarketingPreferences: undefined,
        },
      };
    }
  )
);
